import type { Language } from '@application/types';
import type { ContactPreference } from '@gql/graphql';
import type { MouseEventHandler, ReactNode } from 'react';

export interface MtSettingsBreederPageFormValues {
  language?: Language;
  contactPreferences?: ContactPreference[];
}

export interface MtSettingsBreederPageData {
  mode: 'edit' | 'view';
  onEditClick?: MouseEventHandler;
  onCancelClick?: MouseEventHandler;
  loading?: boolean;
  onChangePasswordClick: () => void;
  onDeleteAccountClick: () => void;
  socialProvidersComponent: ReactNode;
  showChangePassword?: boolean;
  onChangeContactPreferenceClick: (contactPreference: ContactPreference[], value: boolean) => void;
}

export interface MtSettingsPageProps extends MtSettingsBreederPageData {}

export interface BreederContactPreferencesProps
  extends Pick<MtSettingsPageProps, 'mode' | 'onChangeContactPreferenceClick'> {}
